import React, { useEffect, useState } from 'react';
import Alert from '../Alert';

export type Variant = 'success' | 'error' | 'warning';

export interface NotificationProps {
  onClose?: Function;
  delay?: number;
  children?: React.ReactNode;
  variant?: Variant;
  extraClass?: string;
}

function Notification({
  onClose,
  children,
  variant = 'success',
  extraClass,
  delay,
}: NotificationProps) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (!delay) return;
    const timer = setTimeout(() => setShow(false), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  const onClick = () => {
    onClose instanceof Function && onClose();
    setShow(false);
  };

  return (
    <Alert
      show={show}
      variant={variant}
      dismissible
      onClose={onClick}
      className={`w-[378px] max-[576px]:w-full text-left ${extraClass ?? ''}`}
    >
      {children}
    </Alert>
  );
}

export default Notification;
